import React from "react";
import AddIcon from "../../UIComponents/AddIcon";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getMakeSearchList } from "../../Actions/lookupAPI";
import MakeCard from "../../components/Lookup/MakeCard";
import { toast } from "react-toastify";
import axios from "axios";
import API from "../../helpers/api";
import { confirmAlert } from "react-confirm-alert";
import $ from "jquery";
import { getMakeList, getModelsList } from "../../Actions/helpersAPI";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));
let SearchItems = {
  Make: "",
  Model: "",
  PageNumber: 1,
  PageSize: 20,
}
class Make extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        Make: "",
        Model: "",
        PageNumber: 1,
        PageSize: 20,
      },
    };
    this.SearchMake = this.SearchMake.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  SearchMake(pgno) {
    const { dispatch } = this.props;
    this.state.searchData.PageNumber = pgno;
    dispatch({ type: "makeModelSearch", data: this.state.searchData });
    dispatch(getMakeSearchList(this.state.searchData));
  }
  eyeclick(item) {
    const { dispatch, history } = this.props;
    dispatch({ type: "MakeDetailsSuccess", data: item });
    history.push(`/Home/LookupMakeAndModelEdit/${item.makeId}`);
    dispatch({ type: "ModelApplicableServices", data: "" });
  }

  componentDidMount() {
    const { dispatch, makeModelSearch, t } = this.props;
    dispatch(getMakeList());
    dispatch(getModelsList(this.state.searchData.Make));
    if (makeModelSearch) {
      this.state.searchData = makeModelSearch;
    }
    dispatch(getMakeSearchList(this.state.searchData));
    dispatch({ type: "SubBannerTitle", data: "Make And Model" });
    let searchitem = this.state.searchData;
    let _this = this;
    this.keyPressHandler = function (event) {
      var keycode = event.keyCode || event.which;
      if (_this.state.searchData.Make || _this.state.searchData.Model) {
        if (keycode === 13) {
          _this.SearchMake(1);
        }
        else {
          toast.success(t('Toast.Success'), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    }

    $(document).keypress(this.keyPressHandler);
  }


  componentWillUnmount() {

    $(document).off("keypress", this.keyPressHandler);
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "Make") {
      this.props.dispatch(getModelsList(e.target.value));
      this.state.searchData[nodeName] = e.target.value;
    } else if (nodeName === "Model") {
      this.state.searchData[nodeName] = e.target.value;
    }
    this.setState({});
  }
  deleteMake(item) {
    const { t } = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const { dispatch, MakeSearchList } = this.props;
            let makeinfo = {
              lookUpToUpdate: "lookup",
              lookUpId: item.makeId,
              lookUpType: "make",
              lookUpName: item.makeName,
              intervalYear: 0,
              confirmDelete: "yes",
              isDeleted: true,
              modifiedBy: currentuser.name,
              modelList: [],
              modelForDelete: [],
            };
            let url = `${API.PostMakeModel}`;
            axios
              .put(url, makeinfo)
              .then((response) => {
                let searchData = {
                  Make: "",
                  Model: "",
                  PageNumber: this.state.searchData.PageNumber - 1,
                  PageSize: 20,
                };
                if (
                  MakeSearchList.pagination.hasNext === false &&
                  MakeSearchList.data.length === 1
                ) {
                  dispatch(getMakeList());
                  dispatch(getModelsList(searchData.Make));
                  dispatch({ type: "makeModelSearch", data: searchData });
                  dispatch(getMakeSearchList(searchData));
                } else {
                  dispatch(getMakeList());
                  dispatch(getModelsList(searchData.Make));
                  dispatch({ type: "makeModelSearch", data: this.state.searchData });
                  dispatch(getMakeSearchList(this.state.searchData));
                }
                dispatch({
                  type: "putmakeDetailSuccess",
                  data: response.data,
                });
                toast.success(t("confirmAlertMessage.DeletedSuccessMessage"), {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "putMakeDetailFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => { },
        },
      ],
    });
  }

  ClearInput() {
    this.state.searchData.Make = "";
    this.state.searchData.Model = "";
    this.setState({});
    this.props.dispatch({ type: "makeModelSearch", data: this.state.searchData });
    this.props.dispatch(getMakeSearchList(this.state.searchData));
  }

  NewitemNav = () => {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push("/Home/LookupMakeAndModelAdd");
    this.props.dispatch({ type: "MakeApplicableServices", data: "" });
  };

  render() {
    const { showSidePane, MakeSearchList, ModelList, MakeList, t } = this.props;
    console.log("makeresult", MakeSearchList);
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}>
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}>
                        <h5
                          className="card-title ml-2 mt-2 f2"
                          style={{ color: "092a51" }}>
                          {t("MakeAndModelScreen.Title")}
                        </h5>
                        <div className="m-1 flex" onClick={this.NewitemNav}>
                          <span className="mt-1">{t("ShipManagementContent.Add")}</span>
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row">
                        <div
                          className={
                            this.state.showSidePane ? "col-lg-6 " : "col-lg-4 "
                          }
                        >
                          <label className="form-label">{t("ShipEquipmentStatusScreen.Make")}</label>
                          <br></br>
                          <select
                            className="form-control"
                            name="Make"
                            value={this.state.searchData.Make}
                            onChange={(e) => this.handleInputChange(e)}
                          >
                            <option value="">{t("MakeAndModelScreen.SelectMake")}</option>
                            {MakeList &&
                              MakeList.map((makename) => (
                                <option value={makename.name}>{makename.name}</option>
                              ))}
                          </select>
                        </div>
                        <div
                          className={
                            this.state.showSidePane ? "col-lg-6 " : "col-lg-4 "
                          }
                        >
                          <label className="form-label">{t("ShipEquipmentStatusScreen.Model")}</label>
                          <br></br>
                          <select
                            className="form-control"
                            name="Model"
                            value={this.state.searchData.Model}
                            onChange={(e) => this.handleInputChange(e)}
                          >
                            <option value="">{t("MakeAndModelScreen.SelectModel")}</option>
                            {ModelList &&
                              ModelList.map((modelname) => (
                                <option value={modelname.name}>{modelname.name}</option>
                              ))}
                          </select>
                        </div>
                        <div className={"col-lg-12"}>
                          <br></br>
                          <div
                            className="form-group search-btn-col pt-3"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.SearchMake(1)}
                            >
                              {" "}
                              {t("content.Search")}{" "}
                            </button>
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.ClearInput()}
                            >
                              {" "}
                              {t("content.Clear")}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {MakeSearchList ? (
                <MakeCard
                  currentPage={(MakeSearchList.pagination.currentPage - 1) * MakeSearchList.pagination.pageSize}
                  arraylist={MakeSearchList.data}
                  totalRecords={
                    MakeSearchList.pagination.totalcount
                      ? MakeSearchList.pagination.totalcount
                      : 0
                  }
                  pageSize={MakeSearchList.pagination.pageSize}
                  setUpdatedState={(value) => this.SearchMake(value)}
                  eyeclick={(item) => this.eyeclick(item)}
                  deleteMake={(item) => this.deleteMake(item)}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
  openEditScreen() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/EditClient");
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan,
    MakeList: state.MasterScreenReducer.MakeList,
    ModelList: state.MasterScreenReducer.ModelList,
    MakeSearchList: state.lookupReducer.MakeSearchList,
    makeModelSearch: state.lookupReducer.makeModelSearch,
  };
}
export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(Make)));
